$('.list-item.-is-mega').hover(function() {
	$(this).find('.l-header-nav__list.-sub').stop().fadeIn('fast');
}, function() {
	$(this).find('.l-header-nav__list.-sub').stop().fadeOut('fast');
});


$('.l-header-menu-mega__bg').hover(function() {
	$('.l-header-menu-mega').fadeOut('fast');
});